/**
 * Mock 模块：heart_voyage_daily_area_rank
 * 全区日榜：list 12 条 → 本地 pageSize=10 + more；own 对齐当前 pair。
 * @see mockMd/heart_voyage_daily_area_rank.md
 */
import storiesAvatar from '../components/DailyEventPanel/stories-images/stories-avatar.png'
import {
  RelationType,
  type HeartVoyageDailyAreaRankData,
  type HeartVoyageRankPairItem,
} from '../types'

const MOCK_USER_AVATAR = storiesAvatar

const REL_CYCLE = [
  RelationType.Couple,
  RelationType.Confidant,
  RelationType.CloseFriend,
  RelationType.Brother,
  RelationType.Sister,
] as const

const mockPair = (rank: number): HeartVoyageRankPairItem => {
  const isSelf = rank === 4
  const idA = isSelf ? 10001 : 20000 + rank * 2
  const idB = isSelf ? 10002 : 20001 + rank * 2
  return {
    rank,
    score: 20000 - rank * 800,
    pair_key: `${idA}:${idB}`,
    ship_level: Math.max(1, 12 - rank),
    ship_form: ((rank - 1) % 5) + 1,
    rel_type: REL_CYCLE[(rank - 1) % REL_CYCLE.length],
    member_a: {
      id: idA,
      name: isSelf ? 'Alice' : `User${idA}`,
      zy_id: String(idA),
      avatar: MOCK_USER_AVATAR,
      gender: 2,
    },
    member_b: {
      id: idB,
      name: isSelf ? 'Bob' : `User${idB}`,
      zy_id: String(idB),
      avatar: MOCK_USER_AVATAR,
      gender: 1,
    },
  }
}

const list = Array.from({length: 12}, (_, i) => mockPair(i + 1))

/** @see mockMd/heart_voyage_daily_area_rank.md */
export const HeartVoyageDailyAreaRankMock: HeartVoyageDailyAreaRankData = {
  err_msg: '',
  date: '20260812',
  list,
  own: list[3],
  day_countdown: 28800,
}
